import React, { useEffect, useState } from 'react';

import * as Styled from './vision-description.style';

export type VisionDescriptionProps = Omit<
  React.ComponentProps<'textarea'>,
  'onChange' | 'value' | 'onBlur'
> & {
  value?: string;
  onChange: (value: string) => void;
};

export const VisionDescription: React.FC<VisionDescriptionProps> = ({
  value = '',
  onChange,
  ...rest
}) => {
  const [textValue, setTextValue] = useState(value);
  const isFocused = React.useRef(false);

  const onChangeTextarea = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    isFocused.current = true;
    setTextValue(e.target.value);
    onChange(e.target.value);
  };

  const _onBlur = () => {
    isFocused.current = false;
  };

  useEffect(() => {
    if (isFocused.current) {
      return;
    }
    setTextValue(value);
  }, [value]);

  return (
    <Styled.Textarea
      value={textValue}
      onChange={onChangeTextarea}
      onBlur={_onBlur}
      {...rest}
    />
  );
};
